const Path = {
  home: "/",
  contact: "/contact",
  about: "/about",
  newsmedia: "/newsmedia",
  furniture: "/product/furniture",
  doors: "/product/door",
  material: "/material/all",
  material_pvc: "/material/printed",
  material_door: "/material/door",
  material_hollow: "/material/digital",
  material_furniture: "/material/furniture",
  material_row: "/material/row",
  furniture_kitchen: "/product/furniture/kitchen",
  furniture_drawing: "/product/furniture/drawingroom",
  furniture_cabinet: "/product/furniture/cabinate",
  furniture_office: "/product/furniture/office",
}

export default Path